import { gql } from "@apollo/client"

export const CONTRACT_FRAG = gql`
  fragment ContractFrag on ContractType {
    id
    number
    contractCode
    dailyAllowance
    totalPaid
    totalExpense
    totalOutstanding
    status
    startDate
    endDate
    contractType {
      id
      name
    }
  }
`
